import dayjs from "dayjs"

export class HandoverPlanModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new HandoverPlanModel(), obj)

    newObj.fromDate = obj.fromDate ? dayjs(obj.fromDate) : null
    newObj.toDate = obj.toDate ? dayjs(obj.toDate) : null

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
